import Phaser from 'phaser';
import {gsap} from 'gsap';


export default class Question{

    constructor(){
        this.scene = GAME_REF.scene;

        GAME_REF.obj.question = this;

        this.manager = GAME_REF.obj.manager;
        this.dragon = GAME_REF.obj.dragon;

        this.container = null;
        this.sounds = [];

        this.textTimer = null;
        this.shimaTimer = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }


    render(){

        this.scene.tweens.add({
            targets: this.ques,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 300,
            delay: 500,
            ease: 'Back.easeOut',
        });

        this._setNA();
    }


    restart(){
        this.overlay.alpha = 0;

        this.ques.alpha = 0;
        this.ques.setScale(1.15);

        this.shimajiro.alpha = 0;
        this.shimajiro.y = 770;

        this.render();
    }

    
    reRec(){
        GAME_REF.obj.sound.playOne('kaisetsu_na7');
        GAME_REF.obj.recording.reRec();
        this._naTextAnime(1, 1);
    }


    _init(){
        
        for(let i=0; i<7; i++){
            this.sounds.push(`kaisetsu_na${i+1}`);
            if(i==4) this.sounds.push('se_picon');
        }

        this._create();

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    _create(){
        this.container = this.scene.add.container(0, 0);
        this._createOverlay();
        this._createQues();
        this._createShimajiro();
    }

    _createOverlay(){
        this.overlay = this.scene.add.graphics();
        this.overlay.fillStyle(0x000000);
        this.overlay.fillRect(0, 0, 1280, 775);
        this.overlay.alpha = 0;
        this.container.add(this.overlay);
    }

    _createQues(){
        this.ques = this.scene.add.container(640, 160);
        this.ques.alpha = 0;
        this.ques.setScale(1.15);

        this.ques_bg = this.scene.add.graphics();
        this.ques_bg.fillStyle(0x000000, 0.7);
        this.ques_bg.fillRoundedRect(-248, -68, 496, 136, 68);
        
        this.ques_text = this.scene.add.image(-40, 0, 'question');
        this.ques_text.setOrigin(0.5, 0.5);

        this.grapes = this.scene.add.image(155, 0, 'grapes');

        this.ques.add(this.ques_bg);
        this.ques.add(this.ques_text);
        this.ques.add(this.grapes);
        this.container.add(this.ques);
    }

    _createShimajiro(){
        this.shimajiro = this.scene.add.sprite(265, 770, 'shimajiro');
        this.shimajiro.alpha = 0;
        this.container.add(this.shimajiro);

        this.scene.anims.create({
            key: `shimaRecTalk`,
            frames: this.scene.anims.generateFrameNumbers('shimajiro', { start: 2, end: 1}),
            frameRate: 3,
            repeat: -1
        });
    }

    _setNA(){
        GAME_REF.obj.sound.playSequence(this.sounds, ()=>{
            this.manager.recording();
        });

        GAME_REF.obj.sound.setOnSequenceOneStart(key => {

            if(key==='kaisetsu_na2'){
                this._naTextAnime(0, 0);
                this.dragon.jump();
            }
            else if(key==='kaisetsu_na3'){
                this._renderShimajiro();
                this._naTextAnime(4, 1);
                this.dragon.fuwa();
            }
            else if(key==='kaisetsu_na4'){
                this._changeShimajiro();
            }
            else if(key==='kaisetsu_na5'){
                this._talkShimajiro();
                this._naTextAnime(0, 0);
            }
            else if(key==='kaisetsu_na6'){
                this._hideShimajiro();
                this.dragon.stopFuwa();
                GAME_REF.obj.recording.render();
            }
            else if(key==='kaisetsu_na7'){
                this._naTextAnime(1, 1);
            }
            else if(key==='se_picon'){
                this.dragon.jump();
            }
        });
    }


    _renderShimajiro(){

        this.shimaTimer = gsap.delayedCall(3.5, ()=>{
            this.shimaTimer = null;

            this.scene.tweens.add({
                targets: this.shimajiro,
                alpha: 1,
                y: 670,
                duration: 500,
                ease: 'Back.easeOut'
            });
        });

        this.scene.tweens.add({
            targets: this.shimajiro,
            scaleY: 0.99,
            duration: 400,
            ease: 'Sine.easeInOut',
            yoyo: true, 
            repeat: -1
        });
    }

    _changeShimajiro(){
        this.shimajiro.setFrame(1);

        this.scene.tweens.add({
            targets: this.shimajiro,
            y: '-=20', 
            scaleX: 1.1,
            scaleY: 1.1,
            ease: 'Cubic.easeOut', 
            duration: 250, 
            repeat: 0, 
            yoyo: true,
            repeatDelay: 1000
        });
    }

    _talkShimajiro(){
        this.shimajiro.setFrame(1);
        this.shimajiro.anims.play(`shimaRecTalk`);
    }

    _hideShimajiro(){

        this.scene.tweens.add({
            targets: this.shimajiro,
            y: '+=400',
            duration: 700,
            ease: 'Back.easeOut'
        });

        this.shimajiro.anims.stop();
        this.shimajiro.setFrame(1);
    }


    _naTextAnime(_delay=0, _count=-1){

        this.textTimer = gsap.delayedCall(_delay, ()=>{
            this.textTimer = null;
            this._setTextAnime(this.ques_text, 0, _count);
            this._setTextAnime(this.grapes, 0.2, _count);
        });
    }

    _setTextAnime(_target, _delay=0, _count=-1){
        const tl = gsap.timeline({repeat:_count, delay:_delay, repeatDelay:1});
        tl.to(_target, {duration:0.3, y:'-=20', ease:'power2.out'})
        tl.to(_target, {duration:0.2, y:0, ease:'power2.out'});
    }

    _pause(){
        if(this.textTimer) this.textTimer.pause();
        if(this.shimaTimer) this.shimaTimer.pause();
    }

    _resume(){
        if(this.textTimer) this.textTimer.resume();
        if(this.shimaTimer) this.shimaTimer.resume();
    }
}